import { type SubscriberVisibilityKind } from "./edit-subscriber-config-form.types";

const ALL_VISIBILITY_KINDS: SubscriberVisibilityKind[] = [
	"VISIBLE",
	"HIDDEN",
	"ONLY_ADMINS",
	"ONLY_BUSINESS_ACCOUNTS",
	"ONLY_WITH_LICENSE",
	"ONLY_EDITORS",
	"ONLY_AZAV_ACCOUNTS",
	"AFTER_DATE_TIME",
	"NOT_AFTER_DATE_TIME",
];

// ONLY_WITH_LICENSE keys purely on actual license possession, and neither
// "Kurs freischalten" nor "Paywall entfernen" can restore access once it hides
// an offer — so it must not be set from here (DXP-1126). Configs that already
// carry it stay listed, but disabled, so editing an unrelated field cannot
// silently overwrite the visibility.
const NON_SELECTABLE_VISIBILITY_KINDS: SubscriberVisibilityKind[] = ["ONLY_WITH_LICENSE"];

export const isVisibilityKindDisabled = (kind: SubscriberVisibilityKind) =>
	NON_SELECTABLE_VISIBILITY_KINDS.includes(kind);

export const getVisibilityKinds = (currentVisibility: SubscriberVisibilityKind | null) =>
	ALL_VISIBILITY_KINDS.filter(
		(kind) => !isVisibilityKindDisabled(kind) || kind === currentVisibility,
	);
